import { CREATE_INCODE_LINKS, CREATE_INCODE_LINKS_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const createIncodeLinksAction = (params) => async (dispatch) => {
  const { legal_id, order_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/session`,
      {},
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: CREATE_INCODE_LINKS,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: CREATE_INCODE_LINKS_ERROR,
    });
  }
};
